<template>
  <div>
    <div class="bigTitle">定性</div>
    <div class="box">
      <div class="value physicians">
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interviewbg.png" alt="">

        </div>
        <div class="title">深度访谈（IDI）</div>
        <div class="text">
          <div class="one">
           深入访谈 (IDI) 以1对1的方式进行。IDI的参与者有更多的时间发言和回答问题，这有助于对研究主题有更深入的了解。
          </div>
          <div class="two">
             深度访谈还可以让主持人给予受访者充分的关注，我们的主持人也可以调整访谈风格，以便从访谈中获得最大的收获。
          </div>
        </div>
        <div class="more" @click="toPath('/cn//interview?source=webtable')">
          了解更多 ＞
        </div>
      </div>
      <div class="value patient">
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/focusGroup/focuebg.png" alt="">

        </div>
        <div class="title">小组座谈会 / 一对一 / 一对二</div>
        <div class="text">
          <div class="one">
           这些方法将一小群目标人群聚集在一起，回答设计好的问题。作为一个群体，受访者可以提供更细致、更自然的反馈。团队动态在发现过程中是强大的，并导致新的想法和新的发现。

          </div>
          <!-- <div class="two">
            While we recommend that focus groups consist of eight respondents or less, Triads and Duos may be suggested as alternatives for generating ideas while allowing more time each respondent for in-depth questioning.
          </div> -->
        </div>
        <div class="more" @click="toPath('/cn/focus?source=webtable')">
         了解更多 ＞
        </div>
      </div>
      <div class="value consumer">
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/ethnography/ethnographybg.png" alt="">

        </div>
        <div class="title">Ethnography</div>
        <div class="text">
          <div class="one">
           一种定性的方法，涉及到相对深入到一个特定的社区或情境中，近距离观察他们的行为和相互作用
          </div>
        </div>
        <div class="more" @click="toPath('/cn/ethnography?source=webtable')">
          了解更多 ＞
        </div>
      </div>
      <div class="value consumer">
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/gangSurvey/surveybg.png" alt="">

        </div>
        <div class="title">Gang Survey</div>
        <div class="text">
          <div class="one">
           定性和定量研究方法的混合方法。 第一部分:在主持人的监督下，自行完成标准化问卷。每个参与者都收到相同的指示和信息。
          </div>
           <div class="two">
             第二部分:小组讨论最重要的定性问题——基于他们在第一部分中的定量答案。
          </div>
        </div>
        <div class="more" @click="toPath('/cn/gangsurvey?source=webtable')">
          了解更多 ＞
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    toPath(path) {
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.bigTitle {
  font-size: 40px;
  padding: 10px 120px 0;
  font-weight: 700;
}
.box {
  display: flex;
  justify-content: space-between;
  margin: 20px 120px;
  .value {
    width: 24%;
  position: relative;

    // border: 1px solid #000;
    background-color: #2cb1e9;
    padding: 20px 20px 50px;
    color: #fff;
    .title {
      font-size: 20px;
      font-weight: 700;
    }
    .img {
      width: 150px;
      overflow: hidden;
      img {
        width: 300px;
        transform: translateX(-50%); /* 向左平移50%以显示右半边 */
      }
    }

    .text {
      .one,
      .two {
        margin-top: 10px;
      }
    }
    .more {
      // margin-top: 15px;
      position: absolute;
      bottom: 15px;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .bigTitle{
    font-size: 80px;
  }
  .box{
    flex-wrap: wrap;
    .value{
      width: 100%;
      padding: 30px;
      margin-bottom: 20px;
      padding-bottom: 150px;
      .title{
        font-size: 75px;
      }
      .img{
        width: 500px;
        img{
          width: 1000px;
        }
      }
      .text{
        font-size: 70px;
      }
      .more{
        font-size: 70px;
      }
    }
  }
}
</style>